import React from "react";
import { Page } from "../components/Page/Page";
import { SimpleMenu } from "../components/SimpleMenu/SimpleMenu";
import "./PageLayout.css";

export function MainMenuPage() {
  return (
    <Page back={false}>
      <SimpleMenu />
    </Page>
  );
}
